import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { typedQueryClient } from "hooks";
import "modules/ExactMonitoring/components/Billing/components/InvoiceHistoryModal/InvoiceHistoryModal.scss";
import { useInvoices } from "modules/ExactMonitoring/components/Billing/components/InvoiceHistoryModal/services";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";
import { InvoiceTable } from "modules/LocationLicenseOverview/components";

type InvoiceHistoryModalProps = {
  dealerId: number;
  dealerLocationId: number;
  onClose: () => void;
};

export const InvoiceHistoryModal = ({ dealerId, dealerLocationId, onClose }: InvoiceHistoryModalProps) => {
  const { t } = useTranslation();

  const [paginatedURL, setPaginatedURL] = useState("");
  const [currentInvoicePage, setCurrentInvoicePage] = useState(0);

  const {
    paginatedInvoices,
    query: { data: invoices, isLoading: isLoadingInvoices, isRefetching: isRefetchingInvoices }
  } = useInvoices({ paginationUrl: paginatedURL, currentInvoicePage, dealerLocationId, dealerId });

  const handleLocationInvoicePageChange = (pageIndex: number) => {
    if (pageIndex < 0) return;

    if (dealerLocationId) {
      const existingLocationData = paginatedInvoices.data.find(({ id }) => id === dealerLocationId);
      if (existingLocationData && Boolean(existingLocationData.data[pageIndex])) return setCurrentInvoicePage(pageIndex);
    }

    if (dealerId) {
      const existingDealerData = paginatedInvoices.data.find(({ id }) => id === dealerId);
      if (existingDealerData && Boolean(existingDealerData.data[pageIndex])) return setCurrentInvoicePage(pageIndex);
    }

    if (!invoices?.__next) return;
    setPaginatedURL(invoices.__next);
    setCurrentInvoicePage(pageIndex);
  };

  const handleClose = () => {
    onClose();
    setPaginatedURL("");
    setCurrentInvoicePage(0);
    typedQueryClient.resetQueries(ExactFailuresQueryKeys.invoiceHistory);
    typedQueryClient.resetQueries(ExactFailuresQueryKeys.paginatedHistoryInvoices);
  };

  return (
    <Modal open={Boolean(dealerId || dealerLocationId)} onClose={handleClose} closeOnDimmerClick={false} className="InvoiceHistoryModal">
      <Modal.Header className="modal-header">
        <div className="tyres-overview-header-title">{t("v8_succeeded_invoice_history", "Succeeded Invoice History")}</div>
        <Button className="modal-close-btn" basic onClick={handleClose}>
          <Icon className="xmark grey" />
        </Button>
      </Modal.Header>
      <Modal.Content scrolling>
        <InvoiceTable
          invoices={invoices}
          isLoadingInvoices={isLoadingInvoices}
          isRefetchingInvoices={isRefetchingInvoices}
          currentInvoicePage={currentInvoicePage}
          onPageChange={handleLocationInvoicePageChange}
          onInvoiceRowClick={() => {}}
        />
      </Modal.Content>
    </Modal>
  );
};
